// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__a5xku","footer_inner":"Footer_footer_inner__-ggzu","list_wrap":"Footer_list_wrap__bSL7y","copyright":"Footer_copyright__yZEOe"};